module.exports = __webpack_public_path__ + "assets/img/file-scan.0ffa6255.svg";